import React from 'react';
import { UserAccountCard } from '../components';

const AccountView: React.FC = () => {
	return <UserAccountCard finish={() => {}} />;
};

export default AccountView;
